const subheadingsData = {
    1: [
        {
            title: "About Me",
            content: (
                <>
                    <p>
                        <strong>Hello! I'm <i>Jay Pawar</i></strong>, a <strong>WEB Developer</strong> and <strong>Technical Author</strong> from <strong><u>Pune</u></strong>. With 8 months in <strong><u>WDM Authoring</u></strong> and 6 months in <strong><u>MERN STACK</u></strong>, I create user-focused applications and simplify complex tasks for clients.
                    </p>
                    <p>
                        My skills in development and authoring ensure clarity and impact, whether building applications or documenting them. Let’s connect!
                    </p>
                </>

            ),
        },


    ],
    2: [
        {
            title: "2022 Aircraft Manitaince Engineering",
            content: (
                <>
                    <p>
                        Aircraft Manitaince Engineering <br></br>
                        Hindustan Aerospace and Engineering, Pune
                    </p>
                </>
            ),
        },
        {
            title: " Reva-tech Solutions (2023–sep 2024-Feb) Developer InternShip",
            content: (
                <>
                    <p>
                        Collaborated with a dynamic team to build end-to-end web applications using the MERN stack.<br></br>
                        <u>Front-End:</u><br></br>
                        Developed responsive user interfaces using React and Redux.
                        Implemented state management, routing, and component reusability.<br></br>
                        <u>Back-End:</u>
                        Created RESTful APIs using Node.js and Express.<br></br>
                        Designed and optimized database schemas using MongoDB.<br></br>
                        Implemented user authentication and authorization (JWT, OAuth).<br></br>
                    </p>
                </>
            ),
        },
    ],
    3: [
        {
            title: "Cades Studec Technologies (2022 July – 2023 March)",
            content: (
                <>
                    <p>
                        <br></br>
                        <u>Role: </u>SA-WDM Technical Author (GPP,MODE'S) <br></br>
                        <u>Technical Authoring in Airbus A320 Wiring Manuals</u>: Include the ATA chapters (4621, 3448, 3452, 3441, 3152, 3411)<br></br>
                        <u>Tools Used</u>: AIRBUS AXESS GATE, AIRINA, TDUMS, CIRCE, SAMONIT, SAP,GIDOCA<br></br>
                        <u>Responsibilities</u><br></br>
                        1.Making high-quality MOCK-UP'S to the client that is technically accurate by ensuring effective review. <br></br>
                        2.Deliver AWO accurately and Making Sure it Matches Standards of Airbus.<br></br>
                    </p>
                </>
            ),
        },

    ],
};

export default subheadingsData;
